import React, {Component} from 'react'
import InputUnitOfMeasure from "../unit-of-measure/input.component.jsx"

class MeasureInputForm extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            name: this.props.name || '',
            value: this.props.value || '',
            unitOfMeasure: this.props.unitOfMeasure || '',
            onChange: this.props.onChange || function () {},
            help: this.props.help || '',

        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            unitOfMeasure: nextProps.unitOfMeasure || '',
            name: nextProps.name || '',
            value: nextProps.value || '',
            help: nextProps.help || '',
            onChange: nextProps.onChange || function () {},
        })
    }

    render() {
        return(
            <div className={this.state.className}>
                <div className="input-group">
                    <InputUnitOfMeasure
                        id={this.state.name}
                        name={this.state.name}
                        value={this.state.value}
                        unit={this.state.unitOfMeasure}
                        onChange={this.state.onChange}
                    />
                </div>
                <small className="form-text text-muted">
                    {this.state.help}
                </small>
            </div>
        )
    }
}

export default MeasureInputForm


// WEBPACK FOOTER //
// ./src/common/form/measureinput.component.jsx